import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var res;
export const addPurposeTodo = createAsyncThunk('addPurpose', async (data) => {
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'purpose',
            data: {
                "name": data.purpose,
                "status": data.status,
                "type": data.type,
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('token') }
        })
        return res

    } catch (error) {
        return error?.response
    }
})


